/**
 * Background — fond décoratif standardisé du profil Particulier.
 *
 * Composition utilisée par tous les héros et certains "panneaux d'attention"
 * du parcours Particulier :
 *  - couche dot-grid fadé vers le bas
 *  - spot-glow brand au centre haut
 *  - halo top-right brand-100 (chaleureux)
 *  - halo bottom-left accent-100 (énergique)
 *
 * Toujours `pointer-events-none` et `aria-hidden`. À insérer comme premier
 * enfant absolu d'un parent `relative overflow-hidden`.
 */

import { PARTICULIER_HALOS } from '../../../config/audience/particulier.ui';

export interface ParticulierBackgroundProps {
  /** Désactive le halo top-right (utile sur petites sections). */
  hideTopHalo?: boolean;
  /** Désactive le halo bottom-left (utile sur petites sections). */
  hideBottomHalo?: boolean;
  /** Désactive le spot-glow central (gardé par défaut). */
  hideSpot?: boolean;
}

export function ParticulierBackground({
  hideTopHalo = false,
  hideBottomHalo = false,
  hideSpot = false,
}: ParticulierBackgroundProps) {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0">
      <div className="absolute inset-0 dot-grid-masked" />
      {!hideSpot && <div className="spot-glow" />}
      {!hideTopHalo && <div className={PARTICULIER_HALOS.topRight} />}
      {!hideBottomHalo && <div className={PARTICULIER_HALOS.bottomLeft} />}
    </div>
  );
}
